import useSWR from "swr";

export const useFetchLiffUrlByRestaurantId = (restaurantId?: string, liffType?: string) => {
  const fetcherKey = restaurantId ? `external_api/restaurants/${restaurantId}/liff-restaurants/${liffType}/liff-url/` : null;
  const { data: liffUrl, error, isLoading } = useSWR<string>(fetcherKey)
  return { liffUrl, isLoading, error };
};